import Losses35Header from "./Header";
import "./index.css";
import Losses35Table from "./Table";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../components/TableLoadingWrapper";

const Losses35Components = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });

  return (
    <div className="losses-35-container" id="losses-35-id">
      <Losses35Header productId={productId} show={show} />
      <ShowHide show={show} setShow={setShow} />
      {show && (
        <div className="prod-component-contents">
          <TableLoadingWrapper
            tableId={`losses-35-${productId}`}
            minLoadTime={3000}
            maxLoadTime={20000}
          >
            <Losses35Table productId={productId} />
          </TableLoadingWrapper>
        </div>
      )}
    </div>
  );
};

export default Losses35Components;
